var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee1c25",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b4ea2",
    d: "M.7 0H54v26.7H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v13.3H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 30.9c-3.5-1.7-8.6-5.2-8.6-12q.1-10 .3-9.8h16.8s.3 3 .3 9.9c0 6.8-5.1 10.2-8.7 11.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee1c25",
    d: "M20 30c-3.2-1.6-8-4.7-8-11s.4-9 .4-9h15.4q.2-.1.3 9c0 6.3-4.7 9.4-8 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.8 17.4c.9 0 2.6 0 4.2-.4v2.4c-1.4-.5-3.2-.5-4.2-.5v3.4h-1.4V19c-1 0-2.8 0-4.2.5V17c1.6.5 3.3.4 4.2.4v-2.1q-1.3-.1-3.3.4v-2.4q2 .6 3.3.5c0-1.4-.5-3-.5-3h2.3s-.4 1.6-.4 3q1.3.1 3.3-.5v2.4a10 10 0 0 0-3.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b4ea2",
    d: "M20 22c-1.6 0-2.5 2.2-2.5 2.2s-.5-1-1.8-1c-1 0-1.6.8-2 1.5C15.3 27.4 18 29 20 30c2-1 4.7-2.6 6.4-5.3-.4-.7-1.1-1.6-2-1.6a2 2 0 0 0-1.9 1.1s-.8-2.3-2.5-2.3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.c5f95f8f22e9bd8b13ed0d663f015283.svg";
export { ForwardRef as ReactComponent };